module.exports = __webpack_public_path__ + "img/gaggan1.868c3a1d.png";